import {ALL_BUILDING_CONFIGS} from "../../configs/tokens";

export const getTokenConfig = (token) => {
  return ALL_BUILDING_CONFIGS.find(config => config.id === token);
}